import { Injectable } from "@angular/core";
import { HttpClient } from "../shared/wrappers/HttpClient";
import { Approval } from "../models/Approval.model";

@Injectable()
export class InvoiceAttachService {
    constructor(private httpClient: HttpClient) { }

    endPoint: String = "/invoice-attach";

    async getInvoiceHash(hash: any): Promise<Approval> {
        return await this.httpClient.get(`${this.endPoint}/${hash}`);
    }

    async createtInvoiceAttach(data: Approval): Promise<Approval> {
        return await this.httpClient.post(`${this.endPoint}/${data.hash}`, data);
    }

    async updateInvoiceAttach(approval: Approval): Promise<Approval> {
        return await this.httpClient.update(this.endPoint, approval.hash, approval);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/invoice-attach.service.ts